import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function fetchBlogAuthor(options = {}) {
  return function withContext(context) {
    const url = `${API_URL}blog/authors/${options.slug}`;
    return _fetch(url, { withAuth: false }, { method: 'GET' })(context);
  };
}
